import { render, staticRenderFns } from "./SecureHosting.vue?vue&type=template&id=1b458d7c&"
import script from "./SecureHosting.vue?vue&type=script&lang=js&"
export * from "./SecureHosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b458d7c')) {
      api.createRecord('1b458d7c', component.options)
    } else {
      api.reload('1b458d7c', component.options)
    }
    module.hot.accept("./SecureHosting.vue?vue&type=template&id=1b458d7c&", function () {
      api.rerender('1b458d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Accounts/SecureHosting.vue"
export default component.exports